export default {"src":"/_next/static/media/purchasing-power.d35b12b0.svg","height":114,"width":130};